import createActions from 'utils/redux/createActions'

export default createActions([
  'NAVIGATION',
  'OPEN_PREFILTERED'
])



// WEBPACK FOOTER //
// ./src/actions/navigation.js